import { AbstractControl } from '@angular/forms';

export function dateValidator(
  control: AbstractControl
): { [key: string]: any } | null {
  if (!control.value) {
    return null;
  }

  // Accepts yyyy-mm-dd, yyyy/mm/dd, or dd/mm/yyyy
  const regex = /^(\d{4}[-\/]\d{2}[-\/]\d{2}|\d{2}\/\d{2}\/\d{4})$/;
  if (!regex.test(control.value)) {
    return { invalidDate: true };
  }

  let year: number, month: number, day: number;
  if (/^\d{4}[-\/]\d{2}[-\/]\d{2}$/.test(control.value)) {
    // yyyy-mm-dd or yyyy/mm/dd
    const parts = control.value.split(/[-\/]/);
    year = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10);
    day = parseInt(parts[2], 10);
  } else {
    // dd/mm/yyyy format
    const parts = control.value.split('/');
    day = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10);
    year = parseInt(parts[2], 10);
  }

  // JS months are 0-based
  const date = new Date(year, month - 1, day);

  // Check if the date matches the input values
  const isValid =
    !isNaN(date.getTime()) &&
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day;

  return isValid ? null : { invalidDate: true };
}
